import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PermissionGuard } from "~/components/permission-guard";
import { ensureSession } from "~/modules/auth/credentials";

export const Route = createFileRoute("/_dash/linkedin-skills")({
  component: RouteComponent,
  beforeLoad() {
    ensureSession();
  },
});

function RouteComponent() {
  return (
    <PermissionGuard permission="linkedin-skills:manage">
      <Outlet />
    </PermissionGuard>
  );
}
